module.exports = __webpack_public_path__ + "img/news-08.1ec77c33.jpg";